import type { IconDefinition, IconName } from '@fortawesome/fontawesome-svg-core';

/**
 * Font Awesome Pro 7 'message-waveform' (duotone solid), carried as a local
 * definition: the app is on the FA 6 packages, where this icon does not exist
 * yet. Drop this file and import from the package once the FA packages move
 * to 7. Covered by the project's Font Awesome Pro license.
 */
export const faMessageWaveform: IconDefinition = {
    prefix: 'fad',
    iconName: 'message-waveform' as IconName,
    icon: [
        640,
        512,
        [],
        'e6e0',
        [
            'M64 128c0-53 43-96 96-96l320 0c53 0 96 43 96 96l0 156.1c-11.4-7.7-25.2-12.1-40-12.1-6.4 0-12.6 .8-18.6 2.4-12.7-20.6-35.4-34.4-61.4-34.4-31.7 0-58.6 20.5-68.2 49-3.8-.6-7.8-1-11.8-1-39.8 0-72 32.2-72 72l0 112c0 3.9 .3 7.6 .9 11.3l-74.5 55.9c-4.2 3.1-9.2 4.8-14.4 4.8-13.3 0-24-10.7-24-24l0-72-32 0c-53 0-96-43-96-96l0-224z',
            'M456 288c13.3 0 24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24zm80 32c13.3 0 24 10.7 24 24l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24zM376 336c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zm240 32c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24z'
        ]
    ]
};
